// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__vyp6S","buttons":"Footer_buttons__1fhdA"};